import React, { useContext, useEffect, useState } from 'react';
import NewImageForm from '../../b2b-common/NewImageForm';
import { LoginContext } from '../../../App';
import { fetchAPIDataWhileSettingState, generateClassName } from '../../b2b-common/helpers';
import ElementsCarousel from '../../b2b-common/ElementsCarousel';
import { extractLevelNImageParams, getImagesWithActions } from './helper';
import { deleteLevelNImage, fetchLevelNsData, uploadLevelNImage } from '../../../services/b2b-frameworks-apiService';

import './LevelNImages.css';

const LevelNImages = ({ frameworkSuite, levelN, className = null }) => {
    const { loginData } = useContext(LoginContext);
    const [currentLevelN, setCurrentLevelN] = useState(levelN);

    useEffect(() => {
        setCurrentLevelN(levelN);
    }, [levelN]);

    const updateLevelN = async () => {
        const paramsArray = [
            frameworkSuite,
            currentLevelN.frameworkId,
            currentLevelN.levelN_ItemId,
            loginData.accessToken,
            0,     // depth
            false,  // fetchIndicatorDTOs
            true,  // levelNsAddImages
        ];
        const levelN = await fetchAPIDataWhileSettingState(fetchLevelNsData, paramsArray, null);
        setCurrentLevelN(levelN);
    }

    const handleDeleteLevelNImage = async (image) => {
        const deleteParams = extractLevelNImageParams(image);
        try {
            await deleteLevelNImage(frameworkSuite, currentLevelN.frameworkId, currentLevelN.levelN_ItemId, loginData.accessToken, deleteParams);
            await updateLevelN();
        } catch (error) {
            console.error('Failed to delete levelN image:', error.message);
            alert('Failed to delete levelN image. Please try again.');
        }
    }

    const handleLevelNImageUpload = async (file, imageFields) => {
        //console.log(file, imageFields);
        try {
            await uploadLevelNImage(frameworkSuite, currentLevelN.frameworkId, currentLevelN.levelN_ItemId, file, loginData.accessToken, imageFields);
            await updateLevelN();
        } catch (error) {
            console.error('Failed to upload levelN image:', error.message);
            alert('Failed to upload levelN image. Please try again.');
        }
    }

    return (
        (currentLevelN &&
            <div className={generateClassName("leveln-images", "-container", className)}>
                <NewImageForm defaultImageName={"leveln_Image"} onImageUpload={handleLevelNImageUpload} />
                <ElementsCarousel
                    elements={getImagesWithActions(currentLevelN, null, handleDeleteLevelNImage, "leveln-images")}
                    className="leveln-images-carousel"
                />
            </div>
        )
    );
};

export default LevelNImages;